(function($){
    $.JumpButtons = function() { 
        this._component_name = "jump_buttons";
    };

    $.Component.create($.JumpButtons, {
        _init: function() { 
            var jump_buttons  = document.querySelectorAll('.abdo-jump-button');
            for (var i = 0; i < jump_buttons.length; i++) {
                var element = jump_buttons[i];
            
                var location = ABDOUtil.getPointFromDataset(element);
                if (location) {
                    // get point and zoom
                    var zoom = $._get_default_zoom();
                    if ("zoom" in element.dataset) {
                        zoom = parseInt(element.dataset.zoom);
                    }

                    element.addEventListener(ABDOUtil.getClickHandler(element), this._jump_button_click.bind(this, location, zoom));
                }
            }
            this._emit(this._events.ready);
        },

        _jump_button_click: function(location, zoom) {
            var viewer = ABDOUtil.getViewer();

            if(viewer) {
                viewer.viewport.panTo(location).zoomTo(zoom);

                // if tracker disable scroll (to current location)
                if (abdo_osd.tracker) {
                    abdo_osd.tracker.enableScroll(false);
                }
            }
        }
    }, $.OSD);

})(ABDOMap);